



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { OtherAssignment } from '@/models/jobDetail/otherAssignment';
import moment from 'moment';

@Component({})
export default class JobContact extends Vue {
  @Prop({ type: Array, default: (): OtherAssignment[] => [] }) public otherAssignments!: OtherAssignment[];

  formatDateStringForDisplay(dateString: string){
    return moment(dateString).format('DD MMM YYYY');
  }
}

